<template>
  <div class="padding-five-all">
    <b-container fluid>
      <!-- ================= HEADER ================= -->
      <b-card class="mb-3">
        <b-row>
          <b-col md="8">
            <h5 class="mb-0">
              <font-awesome-icon
                icon="exclamation-triangle"
                class="text-warning mr-2"
              />
              Liquidación observada #{{ idLiquidacion }}
            </h5>
          </b-col>
          <b-col md="4" class="text-right">
            <b-button variant="secondary" @click="volverListado">
              Volver
            </b-button>
          </b-col>
        </b-row>
      </b-card>

      <!-- ================= TABLA ================= -->
      <div class="table-scroll">
        <b-table
          bordered
          responsive
          show-empty
          :busy="isBusy"
          :items="ordenes"
          :fields="fields"
          :tbody-tr-class="rowClass"
          details-row
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner />
              <strong>Cargando...</strong>
            </div>
          </template>

          <!-- OBS BACKOFFICE -->
          <template #cell(obsBackoffice)="row">
            <span class="text-danger font-weight-bold">
              {{ row.item.obsBackoffice || "-" }}
            </span>
          </template>

          <!-- OBS PROVEEDOR -->
          <template #cell(obsProveedor)="row">
            <b-form-textarea
              v-if="row.item.estado === 'OBSERVADA'"
              v-model="row.item._obsProveedorTmp"
              rows="2"
              placeholder="Ingrese la subsanación"
            />
            <span v-else>
              {{ row.item.obsProveedor || "-" }}
            </span>
          </template>

          <!-- CONFIRMAR -->
          <template #cell(confirmar)="row">
            <b-button
              v-if="
                row.item.estado === 'PENDIENTE_REVISION' ||
                  row.item.estado === 'OBSERVADA'
              "
              size="sm"
              variant="success"
              @click="confirmarSubsanacion(row.item)"
            >
              ✓
            </b-button>
          </template>
          <template #cell(penalidad)="row">
            <span
              v-if="row.item.penalidades && row.item.penalidades.length"
              class="text-danger font-weight-bold"
              v-b-tooltip.hover
              :title="tooltipPenalidades(row.item)"
            >
              - S/ {{ totalPenalidad(row.item).toFixed(2) }} ({{
                porcentajePenalidad(row.item)
              }}%)
            </span>

            <span v-else class="text-muted">—</span>
          </template>
          <template #row-details="row">
            <b-table
              v-if="row.item.detalles && row.item.detalles.length"
              small
              bordered
              responsive
              :items="row.item.detalles"
              :fields="detalleFields"
            />
          </template>

          <!-- FOOTER -->
          <template #custom-foot="{ columns }">
            <b-tr class="bg-light text-muted small">
              <b-td>SUB TOTALES</b-td>
              <b-td :colspan="7" />
              <b-td class="text-right font-weight-bold">
                {{ subTotalCantidad }}
              </b-td>
              <b-td />
              <!-- costo unitario NO se totaliza -->
              <b-td />
              <!-- costo unitario NO se totaliza -->
              <b-td class="text-right">{{ subTotalSinIgv }}</b-td>
              <b-td class="text-right">{{ subTotalConIgv }}</b-td>
              <b-td :colspan="columns - 14" />
            </b-tr>

            <b-tr class="bg-warning">
              <b-td :colspan="columns" class="text-center">
                <span class="h5 font-weight-bold mr-3">
                  TOTAL A FACTURAR
                </span>
                <span class="h4 font-weight-bold">
                  {{ totalAFacturar }}
                </span>
              </b-td>
            </b-tr>
          </template>
        </b-table>
      </div>

      <!-- ================= ACCIÓN FINAL ================= -->
      <b-row class="mt-3">
        <b-col cols="12" class="text-right">
          <b-button
            variant="primary"
            :disabled="!puedeConfirmar"
            @click="confirmarLiquidacion"
          >
            Liquidación resuelta
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "LiquidacionObservadaDetalleProveedor",

  data() {
    return {
      serviceCache: {},
      isBusy: false,
      idLiquidacion: null,
      ordenes: [],
      detalleFields: [
        { key: "orden", label: "#" },
        { key: "skuServicio", label: "SKU Servicio" },
        { key: "descripcionServicio", label: "Servicio" },
        { key: "skuProducto", label: "SKU Producto" },
        { key: "descripcionProducto", label: "Producto" },
        { key: "cantidad", label: "Cant.", class: "text-right" },
        { key: "costoSinIgv", label: "Costo S/IGV", class: "text-right" },
        { key: "costoConIgv", label: "Costo C/IGV", class: "text-right" },
        { key: "totalSinIgv", label: "Total S/IGV", class: "text-right" },
        { key: "totalConIgv", label: "Total C/IGV", class: "text-right" },
      ],
      fields: [
        { key: "tienda", label: "TIENDA" },
        { key: "detSequenceId", label: "NRO. OS", class: "text-center" },
        { key: "cliente", label: "CLIENTE" },
        {
          key: "skuServicio",
          label: "SKU Servicio",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "descripcionServicio",
          label: "Servicio",
          thStyle: { minWidth: "220px" },
        },
        {
          key: "skuProducto",
          label: "SKU Producto",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "descripcionProducto",
          label: "Producto",
          thStyle: { minWidth: "260px" },
        },
        { key: "cantidad", label: "CANT.", class: "text-right" },
        {
          key: "costoSinIgv",
          label: "Costo S/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "costoConIgv",
          label: "Costo C/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "totalSinIgv",
          label: "Total S/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "totalConIgv",
          label: "Total C/IGV",
          class: "text-right",
          thStyle: { minWidth: "140px" },
        },
        {
          key: "penalidad",
          label: "PENALIDAD",
          class: "text-right text-danger",
        },
        { key: "obsBackoffice", label: "OBS. GESTOR" },
        { key: "obsProveedor", label: "SUBSANACIÓN PROVEEDOR" },
        { key: "confirmar", label: "✓", class: "text-center" },
      ],
    };
  },

  computed: {
    ...mapState("module", ["username", "idProvider", "perfil"]),
    subTotalCantidad() {
      return this.ordenes.reduce((s, i) => s + Number(i.cantidad || 0), 0);
    },
    subTotalCostoSinIgv() {
      return this.ordenes
        .reduce((s, i) => s + Number(i.costoSinIgv || 0), 0)
        .toFixed(2);
    },
    subTotalCostoConIgv() {
      return this.ordenes
        .reduce((s, i) => s + Number(i.costoConIgv || 0), 0)
        .toFixed(2);
    },
    subTotalSinIgv() {
      return this.ordenes
        .reduce((s, i) => s + i.costoSinIgv * i.cantidad, 0)
        .toFixed(2);
    },
    subTotalConIgv() {
      return this.ordenes
        .reduce((s, i) => s + i.costoConIgv * i.cantidad, 0)
        .toFixed(2);
    },
    totalAFacturar() {
      let totalServicios = 0;
      let totalPenalidades = 0;

      for (const os of this.ordenes) {
        // 🧱 OS PADRE
        totalServicios += Number(os.totalSinIgv || 0);
        totalPenalidades += this.totalPenalidad(os);

        // 🧒 OS HIJAS
        if (os.detalles && os.detalles.length) {
          for (const d of os.detalles) {
            totalServicios += Number(d.totalSinIgv || 0);
          }
        }
      }

      return (totalServicios - totalPenalidades).toFixed(2);
    },
    puedeConfirmar() {
      return (
        this.ordenes.length > 0 &&
        this.ordenes.every((o) => o.estado === "ACEPTADA")
      );
    },
  },

  mounted() {
    if (this.perfil !== "PROVEEDOR") {
      this.$router.replace("/404");
      return;
    }

    this.idLiquidacion = Number(this.$route.params.idLiquidacion);
    this.cargarDetalle();
  },

  methods: {
    porcentajePenalidad(os) {
      if (!os.penalidades || !os.penalidades.length) return 0;
      return Math.round(os.penalidades[0].porcentaje * 100);
    },
    tooltipPenalidades(os) {
      return os.penalidades
        .map((p) => `• ${p.descripcion}: S/ ${p.monto.toFixed(2)}`)
        .join("\n");
    },
    totalPenalidad(os) {
      if (!os.penalidades || !os.penalidades.length) return 0;

      return os.penalidades.reduce((sum, p) => sum + Number(p.monto || 0), 0);
    },
    async obtenerCostosServicio(skuServicio, tiendaCodigo) {
      const key = `${skuServicio}-${tiendaCodigo}`;

      if (this.serviceCache[key]) {
        return this.serviceCache[key];
      }

      const { data } = await axios.get(
        `${process.env.VUE_APP_REPORT_VTEX_BASE}/hp/service-system/v1/liquidaciones/servicio-adicional`,
        {
          params: {
            skuServicio,
            tiendaCodigo,
          },
        }
      );

      this.serviceCache[key] = data;
      return data;
    },
    async confirmarLiquidacion() {
      this.isBusy = true;

      try {
        const { data } = await axios.post(
          `${process.env.VUE_APP_REPORT_VTEX_BASE}` +
            `/hp/service-system/v1/liquidaciones/proveedor/confirmar`,
          {
            idLiquidacionCab: this.idLiquidacion,
            usuario: this.username,
          }
        );

        if (!data?.success) {
          throw new Error(
            data?.message || "No se pudo confirmar la liquidación"
          );
        }

        this.$bvToast.toast(data.message, {
          variant: "success",
          solid: true,
        });

        // 👉 Volver al listado
        this.volverListado();
      } catch (e) {
        this.$bvToast.toast(
          e.response?.data?.message ||
            e.response?.data ||
            "Error al confirmar la liquidación",
          { variant: "danger", solid: true }
        );
      } finally {
        this.isBusy = false;
      }
    },
    rowClass(item) {
      if (!item) return "";

      if (item.estado === "OBSERVADA") return "table-warning";

      if (item.estado === "PENDIENTE_REVISION") return "table-success";

      return "";
    },

    async cargarDetalle() {
      this.isBusy = true;

      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_REPORT_VTEX_BASE}` +
            `/hp/service-system/v1/liquidaciones/proveedor/${this.idLiquidacion}/detalle`,
          {
            params: { idProv: this.idProvider },
          }
        );

        this.ordenes = (data?.ordenes || []).map((o) => ({
          ...o,
          _showDetails: o.detalles && o.detalles.length > 0,
          _obsProveedorTmp: o.obsProveedor || "",
        }));

        for (const os of this.ordenes) {
          if (!os.detalles || !os.detalles.length) continue;

          for (const d of os.detalles) {
            const costo = await this.obtenerCostosServicio(
              d.skuServicio,
              os.tienda.split("-")[0]
            );

            d.costoSinIgv = costo.costoSinIgv;
            d.costoConIgv = costo.costoConIgv;
            d.totalSinIgv = costo.costoSinIgv * d.cantidad;
            d.totalConIgv = costo.costoConIgv * d.cantidad;
          }
        }
      } catch (e) {
        this.$bvToast.toast(
          e.response?.data || "Error al cargar el detalle de la liquidación",
          { variant: "danger", solid: true }
        );
      } finally {
        this.isBusy = false;
      }
    },
    confirmarSubsanacion(os) {
      if (!os._obsProveedorTmp || !os._obsProveedorTmp.trim()) {
        this.$bvToast.toast("Debe ingresar la subsanación", {
          variant: "warning",
          solid: true,
        });
        return;
      }

      // ✅ SOLO FRONT
      os.obsProveedor = os._obsProveedorTmp.trim();
      os.estado = "ACEPTADA";
    },

    volverListado() {
      this.$router.push("/liquidaciones");
    },
  },
};
</script>

<style scoped>
.table-scroll {
  max-height: 65vh;
  overflow-y: auto;
  overflow-x: auto;
}

.table-warning {
  background-color: #fff3cd !important;
}

.table-success {
  background-color: #d4edda !important;
}
</style>
